import { AUTH_API } from './auth'
import { COMMON_API } from './common'

export const baseURL = `${process.env.REACT_APP_BASE_API_URL}`

export const API = {
  AUTH: AUTH_API(baseURL),
  COMMON: COMMON_API(baseURL)
}
